module.exports = {
	"articleTitle1": "Op-Ed: Experiencing campus in a different way ",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Francois-Xavier Bagnoud Building (FXB)",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/new-restaurant-secondary",
	"articleSnippet1": "Feb 16, 2017 ... ... technicians' office in the Francois-Xavier Bagnoud Building. ... one of the “\nhidden treasures” of University of Michigan's North Campus in FXB.",
	"articleSnippet2": "",
	"totalMisc": 0,
	"articleTitle2": "",
	"address": "1320 Beal Ave, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/151206/amc.NEW_.Blimpcompetition.12.5.15.09%20copy_0.jpg?itok=8-r7I7i4",
			"author": "Andrew Cohen",
			"caption": "Engineering freshman Ben Gerton presents the blimp designed in his Engineering 100-700 class during Aerospace Day at the FXB Atrium on Saturday."
		}
	],
	"position": {
		"lat": 42.293481,
		"lng": -83.711988
	},
	"tips": [
		{
			"text": "The wave field is right behind this buidling, and it's a really cool sight to see.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/fxb.json
// module id = 881
// module chunks = 0